import React from "react";

import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import { formatCurrency, getAreaAvatarColor } from "@ds-developer/frontend";
import { productCategoryTypeToCategoryTitle } from "@hubcapp/utils";

import { LearnerAreaCardProps } from "../../types";
import AreaAvatar from "../AreaAvatar";
import AreaContainer from "../../Area";
import AreaContent from "../AreaContent";

const LearnerArea: React.FC<LearnerAreaCardProps> = ({ coverage }) => {
  const history = useHistory();

  return (
    <AreaContainer
      avatar={
        <Grid item xs={12} sm={3}>
          {coverage.region.regionName && (
            <AreaAvatar
              initials={coverage.region.regionCode}
              label={coverage.region.regionName}
              color={getAreaAvatarColor(coverage.region.regionName)}
            />
          )}
        </Grid>
      }
      editable
      onClick={() => {
        history.push(`/settings/areas-and-prices/area/${coverage.id}`);
      }}
    >
      <Grid item xs={6} sm={2}>
        <AreaContent
          label="Districts coverage"
          text={`${
            coverage.region.districts.filter(district => district?.covered)
              .length
          } of ${coverage.region.districts.length}`}
        />
      </Grid>
      {coverage.pricing &&
        coverage.pricing.map(pricing => (
          <Grid key={pricing?.id} item xs={3} sm={2}>
            <AreaContent
              label={productCategoryTypeToCategoryTitle(
                pricing?.productCategory.type,
              )}
              text={pricing?.price ? formatCurrency(pricing?.price) : undefined}
            />
          </Grid>
        ))}

      <Grid item xs={2} sm={2}>
        <AreaContent
          label="Discounts"
          text={`${coverage.discounts?.length} of ${coverage.region.discounts?.length}`}
        />
      </Grid>
    </AreaContainer>
  );
};

export default LearnerArea;
